import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col selection:bg-[#CC0000] selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Footer data-id="element-3" />
    </div>;
}